export const httpStatusCode = {
  NOT_FOUND: 404,
}
